<div
  class="ui-textarea"
  [class.ui-textarea--invalid]="invalid()"
  [class.ui-textarea--disabled]="disabled()"
  [class.ui-textarea--readonly]="readonly()"
>
  <!-- Header: label + badge requerimiento -->
  @if (label()) {
    <div class="ui-textarea__header">
      <label class="ui-textarea__label" [attr.for]="inputId()">
        {{ label() }}
      </label>
      @if (showRequirement()) {
        <span
          class="ui-textarea__requirement"
          [class.ui-textarea__requirement--error]="invalid() && required()"
          aria-hidden="true"
        >
          {{ requirementText() }}
        </span>
      }
    </div>
  }

  <!-- Campo -->
  <div
    class="ui-textarea__field"
    [class.ui-textarea__field--invalid]="invalid()"
    [class.ui-textarea__field--disabled]="disabled()"
    [class.ui-textarea__field--readonly]="readonly()"
  >
    <textarea
      #textareaEl
      class="ui-textarea__control"
      [class.ui-textarea__control--resize-none]="resize() === 'none'"
      [class.ui-textarea__control--resize-vertical]="resize() === 'vertical'"
      [class.ui-textarea__control--resize-auto]="resize() === 'auto'"
      [id]="inputId()"
      [attr.name]="name() ?? null"
      [attr.placeholder]="placeholder() || null"
      [attr.rows]="rows()"
      [attr.maxlength]="maxlength() ?? null"
      [attr.minlength]="minlength() ?? null"
      [attr.autocomplete]="autocomplete() ?? null"
      [attr.aria-required]="required() ? 'true' : null"
      [attr.aria-invalid]="invalid() ? 'true' : null"
      [attr.aria-describedby]="ariaDescribedBy()"
      [disabled]="disabled()"
      [readOnly]="readonly()"
      [value]="value()"
      (input)="onInput($event)"
      (blur)="onBlur($event)"
      (focus)="onFocus($event)"
    ></textarea>
  </div>

  @if (
    (message() && invalid() && showMessage()) ||
    (maxlength() !== undefined && showCounter())
  ) {
    <div class="ui-textarea__footer">
      @if (message() && invalid() && showMessage()) {
        <p
          class="ui-textarea__message ui-textarea__message--error"
          [id]="messageId()"
          role="alert"
        >
          {{ message() }}
        </p>
      }

      @if (maxlength() !== undefined && showCounter()) {
        <span
          class="ui-textarea__counter"
          [class.ui-textarea__counter--exceeded]="counterExceeded()"
          [id]="inputId() + '-counter'"
          aria-live="polite"
        >
          {{ charCount() }}&nbsp;/&nbsp;{{ maxlength() }}
        </span>
      }
    </div>
  }
</div>
